import { CoronaTest } from "core/types";
import Translations from "translations/types";

export function getCoronaVaccinatedText({
  corona,
  translations,
}: {
  corona: CoronaTest["corona"];
  translations: Translations;
}): string {
  if (typeof corona?.vaccinated !== "string") {
    return translations.coronaTesting.vaccinationUnknown;
  }

  const vaccinationDetail = corona.vaccinated ? ` : ${corona.vaccinated}` : "";
  return `${translations.coronaTesting.hasBeenVaccinated}${vaccinationDetail}`;
}
